export const ARTICLE = {
  INNO_TEST: 'ARTICLE_INNO_TEST',
  INNO_WORKING: 'ARTICLE_INNO_WORKING',
};
